define.alias("shared/helpers/linkify-html", "settings/helpers/linkify-html");